import React, { useRef, useState } from 'react';
import { useDrop } from 'react-dnd';
import { BiSolidPencil } from 'react-icons/bi';
import { FaChevronDown } from 'react-icons/fa';
import { GoPlus } from 'react-icons/go';
import { IoMdClose } from 'react-icons/io';
import {
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
} from 'reactstrap';

import { ProductSvg } from '../../../../CustomSvg';
import DraggablePinItem from './DraggablePinItem';
import UndraggedDiv from '../../../../Helpers/modal/UndraggedDiv';

 
const PinGroupAccordion = ({
    product,
    drag,
    canDrag,
    movePinToGroup,
    onEdit,
    onRemove,
    onAddGroupProduct,
    onRefresh,
}) => { 
    const accordionOpenRef = useRef([]);
    const [isOpen, setIsOpen] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
 
    const [{ isOver }, drop] = useDrop({
        accept: 'product_pin',
        drop: (draggedItem, monitor) => { 
            if (monitor.didDrop()) return;
            if (draggedItem.fromGroupId !== product.enc_id) {
                movePinToGroup(draggedItem.pin, draggedItem.fromGroupId, product.enc_id);
            }
        },
        collect: (monitor) => ({ isOver: monitor.isOver({ shallow: true }) }),
    });

    const toggleAccordion = () => setIsOpen((prev) => !prev);
    const toggleDropdown  = () => setIsMenuOpen((prev) => !prev);

    return (
        <div
            ref={drop}
            className={`mb-2 pin-group-head ${canDrag ? 'can-drag' : ''} mxx-3`}
            style={{
                border:       isOver ? '2px dashed #f9b74c' : '',
                borderRadius: '6px',
                background:   isOver ? 'rgba(249,183,76,0.07)' : 'transparent',
                transition:   'border 0.15s, background 0.15s',
            }}
        > 
            <div className="drag-wrpr">
                <div className="drag-item pin-group-item"> 
                    <button
                        type="button"
                        className="pin-acc-icon"
                        onClick={toggleAccordion}
                        
                    >
                        <FaChevronDown fontSize={12} style={{
                            transform:  isOpen ? 'rotate(0deg)' : 'rotate(-90deg)',
                            transition: 'transform 0.2s',
                        }}/>
                    </button>
 
                    <div className="magical-words" ref={drag}>
                        <div>
                            <ProductSvg color={product?.product_color ?? '#6A6D73'} />
                        </div>
                        <div>
                            <p>
                                {product.product_name}
                                {product?.floor_plan && ` (${product.floor_plan})`}
                            </p>
                        </div>
                    </div>

                    <div className="flex-grow-1" />
 
                    {canDrag && <UndraggedDiv pinName="product" />}
                    <Dropdown isOpen={isMenuOpen} toggle={toggleDropdown}>
                        <DropdownToggle
                            tag="div"
                            className="edit-square magical-words"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <circle cx="7" cy="2"  r="1.2" fill="currentColor" />
                                <circle cx="7" cy="7"  r="1.2" fill="currentColor" />
                                <circle cx="7" cy="12" r="1.2" fill="currentColor" />
                            </svg>
                        </DropdownToggle>
                        <DropdownMenu right>
                            <DropdownItem
                                tag="div"
                                className="d-flex gap-2 align-items-center"
                                style={{ gap: '0.5rem' }}
                                onClick={(e) => e.stopPropagation()}
                            >
                                <div
                                    className="info-icon plus-icon"
                                    title="Add new pin to group"
                                    onClick={() => { toggleDropdown(); onAddGroupProduct?.(product); }}
                                >
                                    <GoPlus />
                                </div>
                                <div
                                    className="edit-square magical-words"
                                    title="Edit group"
                                    onClick={() => { toggleDropdown(); onEdit?.(product); }}
                                >
                                    <BiSolidPencil fontSize={15} />
                                </div>
                                <div
                                    className="edit-square magical-words"
                                    title="Delete group"
                                    onClick={() => { toggleDropdown(); onRemove?.(product, canDrag); }}
                                >
                                    <IoMdClose fontSize={10} />
                                </div>
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </div>
            </div>
 
            {isOpen && (
                <div className="pin-group-accordian">
                    {product?.group_details?.map((pin, idx) => (
                        <DraggablePinItem
                            key={pin.id ?? idx}
                            pin={pin}
                            product={product}
                            fromGroupId={product.enc_id}
                            onRemove={onRemove}
                            onEdit={onEdit}
                            onRefresh={onRefresh}
                        />
                    ))}
 
                    {(!product?.group_details || product.group_details.length === 0) && (
                        <button
                            type="button"
                            className="pin-group-paceholder"
                            title="Add new pin"
                            onClick={() => onAddGroupProduct?.(product)}
                        >
                            <p>Add Product</p>
                            <GoPlus />
                        </button>
                    )}
 
                    {isOver && (
                        <div
                            style={{
                                textAlign:  'center',
                                padding:    '6px 0',
                                fontSize:   '11px',
                                color:      '#f9b74c',
                                fontWeight: 600,
                            }}
                        >
                            ↓ Drop here to move into this group
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default PinGroupAccordion;
